import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "../../lib/api";
import { getRecent } from "../../lib/recentlyViewed";
import { CategoryCarousel } from "../CategoryCarousel";
import { RecentTile, PER } from "./RecentlyViewed";
import { useHomeFeed } from "../../lib/siteContent";

export const SimilarListings = ({ t, lang, className = "mb-6", desktop = 4 }) => {
  const [items, setItems] = useState([]);
  const feed = useHomeFeed();
  useEffect(() => {
    const ids = getRecent();
    if (ids.length) api.get(`/listings-similar?ids=${ids.join(",")}`).then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (!items.length) return null;
  const setFav = (id, v) => setItems((xs) => xs.map((x) => (x.id === id ? { ...x, is_favorited: v } : x)));
  return (
    <section className={className} data-testid="similar-listings-strip">
      <h2 className="font-display font-bold text-[#12234A] text-base flex items-center gap-1.5 mb-2.5" data-testid="similar-listings-title">
        <Sparkles size={16} className="text-[#F5551E]" /> {feed[`similar_title_${lang}`] || (lang === "fr" ? "Vous aimerez peut-être aussi" : "You might also like")}
      </h2>
      <CategoryCarousel items={items} perView={PER[desktop] || PER[4]} testid="similar-carousel" label={lang === "fr" ? "annonces" : "ads"}
        renderItem={(l, dup) => <RecentTile l={l} t={t} lang={lang} dup={dup} prefix="similar" onFav={(v) => setFav(l.id, v)} />} />
    </section>
  );
};
